import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetSpecialMedicalConditionDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/SpecialMedicalCondition/GetDetail?` + params, null);

export const GetSpecialMedicalConditionList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/SpecialMedicalCondition/GetList?` + params, null);

export const CreateSpecialMedicalCondition = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SpecialMedicalCondition/Create`, data);

export const UpdateSpecialMedicalCondition = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SpecialMedicalCondition/Update`, data);

export const DeleteSpecialMedicalCondition = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SpecialMedicalCondition/Delete`, data);

export const SaveOPDSpecialMedicalCondition = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SpecialMedicalCondition/SaveOPDSpecialMedicalCondition`, data);

export const UpdateOPDSpecialMedicalCondition = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SpecialMedicalCondition/UpdateOPDSpecialMedicalCondition`, data);